// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.studio-landing {
  min-height: 100vh;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, sans-serif;
}

.landing-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

/* Hero Section */
.hero-section {
  display: flex;
  align-items: center;
  min-height: 100vh;
  gap: 60px;
  padding: 80px 0;
}

.hero-content {
  flex: 1 1;
  color: white;
}

.hero-badge {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background: rgba(255, 255, 255, 0.2);
  backdrop-filter: blur(20px);
  padding: 8px 16px;
  border-radius: 20px;
  font-size: 0.9rem;
  font-weight: 600;
  margin-bottom: 30px;
  border: 1px solid rgba(255, 255, 255, 0.3);
}

.hero-title {
  font-size: 4rem;
  font-weight: 800;
  line-height: 1.1;
  margin: 0 0 20px 0;
  text-shadow: 0 4px 8px rgba(0, 0, 0, 0.3);
}

.gradient-text {
  background: linear-gradient(135deg, #f093fb 0%, #f5576c 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.hero-description {
  font-size: 1.3rem;
  line-height: 1.6;
  margin: 0 0 40px 0;
  opacity: 0.9;
  max-width: 500px;
}

.hero-actions {
  display: flex;
  gap: 20px;
  flex-wrap: wrap;
}

.cta-btn {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  padding: 15px 30px;
  border-radius: 12px;
  font-weight: 600;
  text-decoration: none;
  transition: all 0.3s ease;
  font-size: 1.1rem;
  border: none;
  cursor: pointer;
}

.cta-btn.primary {
  background: white;
  color: #667eea;
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.2);
}

.cta-btn.primary:hover {
  transform: translateY(-3px);
  box-shadow: 0 15px 35px rgba(0, 0, 0, 0.3);
}

.cta-btn.secondary {
  background: rgba(255, 255, 255, 0.2);
  color: white;
  border: 2px solid rgba(255, 255, 255, 0.3);
  backdrop-filter: blur(20px);
}

.cta-btn.secondary:hover {
  background: rgba(255, 255, 255, 0.3);
  border-color: rgba(255, 255, 255, 0.5);
  transform: translateY(-3px);
}

.cta-btn.large {
  padding: 18px 40px;
  font-size: 1.2rem;
}

.hero-image {
  flex: 1 1;
  display: flex;
  justify-content: center;
  align-items: center;
}

.image-placeholder {
  width: 400px;
  height: 400px;
  background: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(20px);
  border-radius: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid rgba(255, 255, 255, 0.2);
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.2);
}

.image-placeholder svg {
  font-size: 6rem;
  color: rgba(255, 255, 255, 0.8);
}

/* Features Section */
.features-section {
  padding: 100px 0;
  background: rgba(255, 255, 255, 0.05);
  backdrop-filter: blur(20px);
}

.section-header {
  text-align: center;
  margin-bottom: 60px;
}

.section-header h2 {
  font-size: 2.5rem;
  font-weight: 700;
  color: white;
  margin: 0 0 15px 0;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
}

.section-header p {
  font-size: 1.2rem;
  color: rgba(255, 255, 255, 0.8);
  margin: 0;
}

.features-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 30px;
}

.feature-card {
  background: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(20px);
  border-radius: 20px;
  padding: 40px 30px;
  text-align: center;
  border: 1px solid rgba(255, 255, 255, 0.2);
  transition: all 0.3s ease;
}

.feature-card:hover {
  transform: translateY(-10px);
  background: rgba(255, 255, 255, 0.15);
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.2);
}

.feature-icon {
  width: 80px;
  height: 80px;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 25px;
  font-size: 2rem;
  color: white;
}

.feature-card h3 {
  font-size: 1.4rem;
  font-weight: 600;
  color: white;
  margin: 0 0 15px 0;
}

.feature-card p {
  color: rgba(255, 255, 255, 0.8);
  line-height: 1.6;
  margin: 0;
}

/* Benefits Section */
.benefits-section {
  padding: 100px 0;
}

.benefits-content {
  display: flex;
  align-items: center;
  gap: 60px;
}

.benefits-text {
  flex: 1 1;
  color: white;
}

.benefits-text h2 {
  font-size: 2.5rem;
  font-weight: 700;
  margin: 0 0 20px 0;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
}

.benefits-text p {
  font-size: 1.2rem;
  line-height: 1.6;
  margin: 0 0 30px 0;
  opacity: 0.9;
}

.benefits-list {
  list-style: none;
  padding: 0;
  margin: 0 0 40px 0;
}

.benefits-list li {
  display: flex;
  align-items: center;
  gap: 15px;
  margin-bottom: 15px;
  font-size: 1.1rem;
}

.benefits-list li svg {
  color: #4ade80;
  font-size: 1.2rem;
}

.benefits-image {
  flex: 1 1;
  display: flex;
  justify-content: center;
  align-items: center;
}

.benefits-image .image-placeholder {
  width: 350px;
  height: 350px;
}

/* CTA Section */
.cta-section {
  padding: 100px 0;
  text-align: center;
  background: rgba(255, 255, 255, 0.05);
  backdrop-filter: blur(20px);
}

.cta-content h2 {
  font-size: 2.5rem;
  font-weight: 700;
  color: white;
  margin: 0 0 20px 0;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
}

.cta-content p {
  font-size: 1.2rem;
  color: rgba(255, 255, 255, 0.8);
  margin: 0 0 40px 0;
}

.cta-actions {
  display: flex;
  justify-content: center;
}

/* Responsive Design */
@media (max-width: 1024px) {
  .hero-section {
    flex-direction: column;
    text-align: center;
    gap: 40px;
  }
  
  .benefits-content {
    flex-direction: column;
    text-align: center;
  }
  
  .hero-title {
    font-size: 3rem;
  }
  
  .image-placeholder {
    width: 300px;
    height: 300px;
  }
  
  .benefits-image .image-placeholder {
    width: 280px;
    height: 280px;
  }
}

@media (max-width: 768px) {
  .landing-container {
    padding: 0 15px;
  }
  
  .hero-section {
    padding: 60px 0;
  }
  
  .hero-title {
    font-size: 2.5rem;
  }
  
  .hero-description {
    font-size: 1.1rem;
  }
  
  .hero-actions {
    justify-content: center;
  }
  
  .features-section,
  .benefits-section,
  .cta-section {
    padding: 60px 0;
  }
  
  .section-header h2,
  .benefits-text h2,
  .cta-content h2 {
    font-size: 2rem;
  }
  
  .features-grid {
    grid-template-columns: 1fr;
    gap: 20px;
  }
  
  .feature-card {
    padding: 30px 20px;
  }
  
  .image-placeholder {
    width: 250px;
    height: 250px;
  }
  
  .image-placeholder svg {
    font-size: 4rem;
  }
  
  .benefits-image .image-placeholder {
    width: 220px;
    height: 220px;
  }
}

@media (max-width: 480px) {
  .hero-title {
    font-size: 2rem;
  }
  
  .hero-description {
    font-size: 1rem;
  }
  
  .cta-btn {
    padding: 12px 24px;
    font-size: 1rem;
  }
  
  .cta-btn.large {
    padding: 15px 30px;
    font-size: 1.1rem;
  }
  
  .feature-card {
    padding: 25px 15px;
  }
  
  .feature-icon {
    width: 60px;
    height: 60px;
    font-size: 1.5rem;
  }
  
  .image-placeholder {
    width: 200px;
    height: 200px;
  }
  
  .image-placeholder svg {
    font-size: 3rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/photo-studio/StudioLanding.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,6DAA6D;EAC7D,mEAAmE;AACrE;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,oCAAoC;EACpC,2BAA2B;EAC3B,iBAAiB;EACjB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,0CAA0C;AAC5C;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,yCAAyC;AAC3C;;AAEA;EACE,6DAA6D;EAC7D,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,iBAAiB;EACjB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,yCAAyC;AAC3C;;AAEA;EACE,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA;EACE,oCAAoC;EACpC,YAAY;EACZ,0CAA0C;EAC1C,2BAA2B;AAC7B;;AAEA;EACE,oCAAoC;EACpC,sCAAsC;EACtC,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,oCAAoC;EACpC,2BAA2B;EAC3B,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,0CAA0C;EAC1C,0CAA0C;AAC5C;;AAEA;EACE,eAAe;EACf,+BAA+B;AACjC;;AAEA,qBAAqB;AACrB;EACE,gBAAgB;EAChB,qCAAqC;EACrC,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,yCAAyC;AAC3C;;AAEA;EACE,iBAAiB;EACjB,+BAA+B;EAC/B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,oCAAoC;EACpC,2BAA2B;EAC3B,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,0CAA0C;EAC1C,yBAAyB;AAC3B;;AAEA;EACE,4BAA4B;EAC5B,qCAAqC;EACrC,0CAA0C;AAC5C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,+BAA+B;EAC/B,gBAAgB;EAChB,SAAS;AACX;;AAEA,qBAAqB;AACrB;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,SAAO;EACP,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,yCAAyC;AAC3C;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,aAAa;AACf;;AAEA,gBAAgB;AAChB;EACE,gBAAgB;EAChB,kBAAkB;EAClB,qCAAqC;EACrC,2BAA2B;AAC7B;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,yCAAyC;AAC3C;;AAEA;EACE,iBAAiB;EACjB,+BAA+B;EAC/B,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,uBAAuB;AACzB;;AAEA,sBAAsB;AACtB;EACE;IACE,sBAAsB;IACtB,kBAAkB;IAClB,SAAS;EACX;;EAEA;IACE,sBAAsB;IACtB,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,YAAY;IACZ,aAAa;EACf;;EAEA;IACE,YAAY;IACZ,aAAa;EACf;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;;;IAGE,eAAe;EACjB;;EAEA;;;IAGE,eAAe;EACjB;;EAEA;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,YAAY;IACZ,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,YAAY;IACZ,aAAa;EACf;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,iBAAiB;EACnB;;EAEA;IACE,YAAY;IACZ,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":[".studio-landing {\n  min-height: 100vh;\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  font-family: 'Inter', -apple-system, BlinkMacSystemFont, sans-serif;\n}\n\n.landing-container {\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 0 20px;\n}\n\n/* Hero Section */\n.hero-section {\n  display: flex;\n  align-items: center;\n  min-height: 100vh;\n  gap: 60px;\n  padding: 80px 0;\n}\n\n.hero-content {\n  flex: 1;\n  color: white;\n}\n\n.hero-badge {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  background: rgba(255, 255, 255, 0.2);\n  backdrop-filter: blur(20px);\n  padding: 8px 16px;\n  border-radius: 20px;\n  font-size: 0.9rem;\n  font-weight: 600;\n  margin-bottom: 30px;\n  border: 1px solid rgba(255, 255, 255, 0.3);\n}\n\n.hero-title {\n  font-size: 4rem;\n  font-weight: 800;\n  line-height: 1.1;\n  margin: 0 0 20px 0;\n  text-shadow: 0 4px 8px rgba(0, 0, 0, 0.3);\n}\n\n.gradient-text {\n  background: linear-gradient(135deg, #f093fb 0%, #f5576c 100%);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n}\n\n.hero-description {\n  font-size: 1.3rem;\n  line-height: 1.6;\n  margin: 0 0 40px 0;\n  opacity: 0.9;\n  max-width: 500px;\n}\n\n.hero-actions {\n  display: flex;\n  gap: 20px;\n  flex-wrap: wrap;\n}\n\n.cta-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 10px;\n  padding: 15px 30px;\n  border-radius: 12px;\n  font-weight: 600;\n  text-decoration: none;\n  transition: all 0.3s ease;\n  font-size: 1.1rem;\n  border: none;\n  cursor: pointer;\n}\n\n.cta-btn.primary {\n  background: white;\n  color: #667eea;\n  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.2);\n}\n\n.cta-btn.primary:hover {\n  transform: translateY(-3px);\n  box-shadow: 0 15px 35px rgba(0, 0, 0, 0.3);\n}\n\n.cta-btn.secondary {\n  background: rgba(255, 255, 255, 0.2);\n  color: white;\n  border: 2px solid rgba(255, 255, 255, 0.3);\n  backdrop-filter: blur(20px);\n}\n\n.cta-btn.secondary:hover {\n  background: rgba(255, 255, 255, 0.3);\n  border-color: rgba(255, 255, 255, 0.5);\n  transform: translateY(-3px);\n}\n\n.cta-btn.large {\n  padding: 18px 40px;\n  font-size: 1.2rem;\n}\n\n.hero-image {\n  flex: 1;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.image-placeholder {\n  width: 400px;\n  height: 400px;\n  background: rgba(255, 255, 255, 0.1);\n  backdrop-filter: blur(20px);\n  border-radius: 20px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.2);\n}\n\n.image-placeholder svg {\n  font-size: 6rem;\n  color: rgba(255, 255, 255, 0.8);\n}\n\n/* Features Section */\n.features-section {\n  padding: 100px 0;\n  background: rgba(255, 255, 255, 0.05);\n  backdrop-filter: blur(20px);\n}\n\n.section-header {\n  text-align: center;\n  margin-bottom: 60px;\n}\n\n.section-header h2 {\n  font-size: 2.5rem;\n  font-weight: 700;\n  color: white;\n  margin: 0 0 15px 0;\n  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);\n}\n\n.section-header p {\n  font-size: 1.2rem;\n  color: rgba(255, 255, 255, 0.8);\n  margin: 0;\n}\n\n.features-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));\n  gap: 30px;\n}\n\n.feature-card {\n  background: rgba(255, 255, 255, 0.1);\n  backdrop-filter: blur(20px);\n  border-radius: 20px;\n  padding: 40px 30px;\n  text-align: center;\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  transition: all 0.3s ease;\n}\n\n.feature-card:hover {\n  transform: translateY(-10px);\n  background: rgba(255, 255, 255, 0.15);\n  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.2);\n}\n\n.feature-icon {\n  width: 80px;\n  height: 80px;\n  background: rgba(255, 255, 255, 0.2);\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin: 0 auto 25px;\n  font-size: 2rem;\n  color: white;\n}\n\n.feature-card h3 {\n  font-size: 1.4rem;\n  font-weight: 600;\n  color: white;\n  margin: 0 0 15px 0;\n}\n\n.feature-card p {\n  color: rgba(255, 255, 255, 0.8);\n  line-height: 1.6;\n  margin: 0;\n}\n\n/* Benefits Section */\n.benefits-section {\n  padding: 100px 0;\n}\n\n.benefits-content {\n  display: flex;\n  align-items: center;\n  gap: 60px;\n}\n\n.benefits-text {\n  flex: 1;\n  color: white;\n}\n\n.benefits-text h2 {\n  font-size: 2.5rem;\n  font-weight: 700;\n  margin: 0 0 20px 0;\n  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);\n}\n\n.benefits-text p {\n  font-size: 1.2rem;\n  line-height: 1.6;\n  margin: 0 0 30px 0;\n  opacity: 0.9;\n}\n\n.benefits-list {\n  list-style: none;\n  padding: 0;\n  margin: 0 0 40px 0;\n}\n\n.benefits-list li {\n  display: flex;\n  align-items: center;\n  gap: 15px;\n  margin-bottom: 15px;\n  font-size: 1.1rem;\n}\n\n.benefits-list li svg {\n  color: #4ade80;\n  font-size: 1.2rem;\n}\n\n.benefits-image {\n  flex: 1;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.benefits-image .image-placeholder {\n  width: 350px;\n  height: 350px;\n}\n\n/* CTA Section */\n.cta-section {\n  padding: 100px 0;\n  text-align: center;\n  background: rgba(255, 255, 255, 0.05);\n  backdrop-filter: blur(20px);\n}\n\n.cta-content h2 {\n  font-size: 2.5rem;\n  font-weight: 700;\n  color: white;\n  margin: 0 0 20px 0;\n  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);\n}\n\n.cta-content p {\n  font-size: 1.2rem;\n  color: rgba(255, 255, 255, 0.8);\n  margin: 0 0 40px 0;\n}\n\n.cta-actions {\n  display: flex;\n  justify-content: center;\n}\n\n/* Responsive Design */\n@media (max-width: 1024px) {\n  .hero-section {\n    flex-direction: column;\n    text-align: center;\n    gap: 40px;\n  }\n  \n  .benefits-content {\n    flex-direction: column;\n    text-align: center;\n  }\n  \n  .hero-title {\n    font-size: 3rem;\n  }\n  \n  .image-placeholder {\n    width: 300px;\n    height: 300px;\n  }\n  \n  .benefits-image .image-placeholder {\n    width: 280px;\n    height: 280px;\n  }\n}\n\n@media (max-width: 768px) {\n  .landing-container {\n    padding: 0 15px;\n  }\n  \n  .hero-section {\n    padding: 60px 0;\n  }\n  \n  .hero-title {\n    font-size: 2.5rem;\n  }\n  \n  .hero-description {\n    font-size: 1.1rem;\n  }\n  \n  .hero-actions {\n    justify-content: center;\n  }\n  \n  .features-section,\n  .benefits-section,\n  .cta-section {\n    padding: 60px 0;\n  }\n  \n  .section-header h2,\n  .benefits-text h2,\n  .cta-content h2 {\n    font-size: 2rem;\n  }\n  \n  .features-grid {\n    grid-template-columns: 1fr;\n    gap: 20px;\n  }\n  \n  .feature-card {\n    padding: 30px 20px;\n  }\n  \n  .image-placeholder {\n    width: 250px;\n    height: 250px;\n  }\n  \n  .image-placeholder svg {\n    font-size: 4rem;\n  }\n  \n  .benefits-image .image-placeholder {\n    width: 220px;\n    height: 220px;\n  }\n}\n\n@media (max-width: 480px) {\n  .hero-title {\n    font-size: 2rem;\n  }\n  \n  .hero-description {\n    font-size: 1rem;\n  }\n  \n  .cta-btn {\n    padding: 12px 24px;\n    font-size: 1rem;\n  }\n  \n  .cta-btn.large {\n    padding: 15px 30px;\n    font-size: 1.1rem;\n  }\n  \n  .feature-card {\n    padding: 25px 15px;\n  }\n  \n  .feature-icon {\n    width: 60px;\n    height: 60px;\n    font-size: 1.5rem;\n  }\n  \n  .image-placeholder {\n    width: 200px;\n    height: 200px;\n  }\n  \n  .image-placeholder svg {\n    font-size: 3rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
